import { SourceDataInitials } from '@/constants/SourceDataInitials';
import ICompAddresses from '../comp/ICompAddresses';
import CompFinalSourceDatasUtils from './CompFinalSourceDatasUtils';
import ICompFinalData from './ICompFinalData';

export default {
    containsTransferValueFromSource(compFinalData: ICompFinalData, sourceInitial: SourceDataInitials): boolean {
        for (const compFinalProperty of compFinalData) {
            const exists = CompFinalSourceDatasUtils.containsValueFromSource(compFinalProperty.sourceData, sourceInitial);
            if (exists) {
                return true;
            }
        }

        return false;
    },

    containsTransferValueFromSource36(compFinalDataForExport: any, sourceInitial: SourceDataInitials): boolean {
        for (const compFinalProperty of compFinalDataForExport) {
            const exists = CompFinalSourceDatasUtils.containsValueFromSource36(compFinalProperty.sourceData, sourceInitial);
            if (exists) {
                return true;
            }
        }

        return false;
    },

    getCompAddresses(compFinalData: ICompFinalData): ICompAddresses {
        const compAddresses: ICompAddresses = [];

        for (const compFinalProperty of compFinalData) {
            compAddresses.push(compFinalProperty.address);
        }
        return compAddresses;
    }
};
